// Services
import callAPI from "../callApi";
import path from "../variables";

/**
 * Clients (personnes réutilisées par les passagers, expéditeurs de
 * colis, etc.). Utilisé par la recherche rapide au guichet.
 */
const Customers = {
	/**
	 * Recherche rapide d'un client existant — par nom, téléphone ou
	 * numéro de pièce. `params` : "?station=<id>&search=<terme>".
	 */
	search: (params?: any) =>
		callAPI(
			"GET",
			`${path.base}/operation/customers/search${params ? params : ""}`,
			"",
			"quick customer search",
		),
};

export default Customers;
